var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gift-card',{staticClass:"selected-gift-card",attrs:{"variant":"primary","logo_src":_vm.product.logo_white,"category":_vm.product.category,"validity":_vm.validity}},[_c('gift-card-value',{attrs:{"amount":_vm.selected_amount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }